import {
    put,
    call,
    select,
    takeEvery
} from 'redux-saga/effects';
import {
    BUY_PLAN,
    SET_TOTAL_TRACKER,
    SET_ORDER_ID,
    SET_SHIPPING_COST,
    SET_SUBSC_ID
} from 'actions/checkout';
import API from 'api';
import {
    formatShipping
} from 'helper';
import {
    SPINNER,
    MODAL
} from 'actions/popup';

const FB_PIXEL_ID = process.env.FB_PIXEL_ID;


function* buy() {
    const {
        main: {
            plan,
            nonce,
            coupon
        },
        form,
        user: {
            token,
            appsflyerId,
            userInfo: { geozilla_user_id }
        },
        card: {
            cardBrand,
            lastFour
        }
    } = yield select();
    const eventId = `${nonce}_${geozilla_user_id}`;
    const shipping = formatShipping(form, nonce);
    const res = {};
    yield put({
        type: SPINNER
    });


    try {
        if (plan === 'device-only') {

            const resTracker = yield call(API.buyTracker, {
                token: nonce,
                coupon,
                count: 1,
                ...shipping
            });
            Object.assign(res, resTracker);
        }
        if (plan === '1-month-plan') {
            const resSunscribe = yield call(API.buySubscriptions, {
                token,
                payment_method_nonce: nonce,
                card_brand: cardBrand,
                card_last_four: lastFour,
                appsflyer_id: appsflyerId

            });
            Object.assign(res, resSunscribe);

            yield put({
                type: SET_SUBSC_ID,
                payload: res.subscription_id
            });
        }

        if (plan === 'app-device-bundle') {
            const resBundle = yield call(API.buyBundle, {
                token,
                ...shipping,
                appsflyer_id: appsflyerId
            });

            Object.assign(res, resBundle);
        }

        if (plan === 'mega-sale') {
            const resBundle = yield call(API.buyMegaBundle, {
                token,
                ...shipping,
                appsflyer_id: appsflyerId,
                items: [{
                    'sku': 'monthly_megasale_19_00',
                    'type': 'ai_package'
                }],
                fb_event_id: eventId,
                fb_pixel_id: FB_PIXEL_ID,
                user_data: {
                    "source_url": encodeURIComponent(window.location.href),
                }
            });

            Object.assign(res, resBundle);
        }

        if (plan === 'yepzon-checkout') {
            const resBundle = yield call(API.buyMegaBundle, {
                token,
                ...shipping,
                appsflyer_id: appsflyerId,
                items: [{
                    'sku': 'monthly_megasale_yepzone_29_00',
                    'type': 'ai_package'
                }]
            });

            Object.assign(res, resBundle);
        }


        yield put({
            type: BUY_PLAN.SUCCESS,
            payload: res
        });

        if (plan === 'app-device-bundle' || plan === 'mega-sale' || plan === 'yepzon-checkout') {
            yield put({
                type: SET_ORDER_ID,
                payload: res.order_id
            });
        }

        yield put({
            type: SET_ORDER_ID,
            payload: res.order.order_id
        });

    } catch (error) {
        yield put({
            type: BUY_PLAN.FAILURE,
            payload: {
                type: 'payment',
                show: true,
                body: 'Check if your funds are sufficient, limits are set right, etc.'
            }
        });
        yield put({
            type: MODAL,
            payload: {modalType: 'error'}
        });
    }
    yield put({
        type: SPINNER
    });

}

function* buyFlow() {
    yield takeEvery(BUY_PLAN.REQUEST, buy);
}

function* calculateOrder() {
    yield put({
        type: SPINNER
    });

    try {
        const {
            main: {
                plan,
                paymentType,
                coupon
            },
            form
        } = yield select();

        const shipping = formatShipping(form, paymentType);

        let params = {
            count: 1,
            ...shipping,
            coupon,
        };

        let customParams;

        switch (plan) {
            case 'device-only':
                customParams = {
                    items: [{
                        type: 'trackimo_device',
                        sku: 'v2'
                    }]
                };
                break;

            case 'mega-sale':
                customParams = {
                    type: '4',
                    items: [{
                        type: 'ai_package',
                        sku: 'monthly_megasale_19_00'
                    }]
                };

                break;

            case 'yepzon-checkout':
                customParams = {
                    type: '4',
                    items: [{
                        type: 'ai_package',
                        sku: 'monthly_megasale_yepzone_29_00'
                    }]
                };

                break;

            default:
                customParams = {
                    items: [{
                        type: 'trackimo_device',
                        sku: 'v2'
                    }]
                };
        }

        Object.assign(params, customParams);


        const {
            pricing
        } = yield call(API.calculateTracker, {...params});

        yield put({
            type: SET_TOTAL_TRACKER.SUCCESS,
            payload: pricing.total
        });
        yield put({
            type: SET_SHIPPING_COST.SUCCESS,
            payload: {
                shippingCost: pricing.shipment_total,
                salesTax: pricing.sales_taxes_total
            }
        });
    } catch (error) {
        yield put({
            type: ({
                type: SET_TOTAL_TRACKER.FAILURE,
                payload: {
                    type: 'logout',
                    show: true,
                    body: 'Something went wrong'
                }
            })
        });
    }
    yield put({
        type: SPINNER
    });

}

function* calculateFlow() {
    yield takeEvery(SET_TOTAL_TRACKER.REQUEST, calculateOrder);
}


export default [
    buyFlow,
    calculateFlow
];